<app-page-header [title]="'Country Details'" [subtitle]="'View details of the selected country'"></app-page-header>
<div class="mb-5">
    <h2 class="text-2xl">{{ country?.name }}</h2>
    <p><strong>DEP Market Name:</strong> {{ country?.depMarketName || 'N/A' }}</p>
    <p><strong>ID:</strong> {{ country?.id }}</p>
    <p><strong>Created By:</strong> {{ country?.createdBy | roleName }}</p>
    <p><strong>Updated By:</strong> {{ country?.updatedBy | roleName }}</p>
    @if (languages.length) {
        <div>
            <h3 class="font-semibold text-xl mt-4">Languages</h3>
            <ul>
                @for (language of languages; track language) {
                    <li>
                        {{ language.name }} ({{ language.localeKey }})
                    </li>
                }
            </ul>
    </div>
    }
</div>

<div class="flex justify-between gap-2">
    <div>
        <p-button (click)="openEditDialog()" icon="pi pi-pencil" isAdmin label="Edit" text></p-button>
        <p-button (click)="confirmDelete()" icon="pi pi-trash" isAdmin label="Delete" severity="danger" text></p-button>
    </div>
    <p-button label="Back to Countries" icon="pi pi-arrow-left" routerLink="/countries"></p-button>
</div>

<!-- Update Dialog -->
<app-update-country-dialog
        [(visible)]="displayUpdateDialog"
        [country]="editableCountry"
        (countryUpdated)="reloadCountryDetails()"
></app-update-country-dialog>
